
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import MetalEstimationCTA from "@/components/MetalEstimationCTA";
import AchatMetauxHero from "@/components/achat-metaux/AchatMetauxHero";
import WhyChooseUs from "@/components/achat-metaux/WhyChooseUs";
import MetalTypesGrid from "@/components/achat-metaux/MetalTypesGrid";
import CustomerTestimonials from "@/components/achat-metaux/CustomerTestimonials";
import ExpertiseZones from "@/components/achat-metaux/ExpertiseZones";
import FAQ from "@/components/achat-metaux/FAQ";
import ContactSection from "@/components/achat-metaux/ContactSection";

const AchatMetaux = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Achat de Métaux et Ferrailles - Groupe Fabre Environnement",
    "description": "Spécialiste du rachat de métaux ferreux et non ferreux. Prix attractifs, expertise reconnue, service professionnel dans toute l'Occitanie.",
    "provider": {
      "@type": "Organization",
      "name": "Groupe Fabre Environnement",
      "url": "https://www.groupefabre-environnement.fr"
    },
    "areaServed": ["Aveyron", "Haute-Garonne", "Tarn", "Lot", "Cantal", "Lozère", "Hérault", "Tarn-et-Garonne", "Val-d'Oise"],
    "serviceType": "Achat et recyclage de métaux",
    "offers": {
      "@type": "Offer",
      "description": "Rachat de tous types de métaux aux meilleurs prix du marché"
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat de Métaux et Ferrailles - Meilleurs Prix Garantis | Groupe Fabre Environnement" 
        description="✓ Rachat métaux ferreux et non ferreux ✓ Meilleurs prix du marché ✓ Cuivre, aluminium, inox, ferraille ✓ Expertise 25+ ans ✓ Paiement immédiat ✓ Devis gratuit" 
        canonical="/nos-services/achat-metaux" 
        keywords="achat métaux, rachat ferraille, prix métaux, ferrailleur, cuivre, aluminium, inox, recyclage métaux, cours métaux, vente métaux" 
      />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <Navbar />
      
      <main className="flex-1">
        <AchatMetauxHero />
        <WhyChooseUs />
        <MetalTypesGrid />
        <MetalEstimationCTA />
        <CustomerTestimonials />
        <ExpertiseZones />
        <FAQ />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetaux;
